import React from 'react'
import PropTypes from 'prop-types'
import {withStyles, Typography, Grid} from 'material-ui'
import Title from './title.jsx'
import CheckCircleIcon from 'material-ui-icons/CheckCircle'
import HomeIcon from 'material-ui-icons/Home'
import DateRangeIcon from 'material-ui-icons/DateRange'
import ScheduleIcon from 'material-ui-icons/Schedule'
import MonetizationOnIcon from 'material-ui-icons/MonetizationOn'
import moment from 'moment'

const formatNumber = number => number
  .toFixed(2)
  .replace('.', ',')
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    maxWidth: 500,
    width: '100%',
    marginBottom: 40,
    margin: 'auto',
    backgroundColor: 'white',
    padding: '15px 25px 15px',
    boxShadow: theme.shadows[2],
    borderRadius: 2,
  },
  titleContainer: {
    marginBottom: 10,
  },
  title: {
    padding: '0 45px',
  },
  item: {
    borderBottom: 'solid 1px #dcdcdc',
    margin: 0
  },
  labelContainer: {
    display: 'flex',
  },
  label: {
    alignItems: 'center',
  },
  valueContainer: {},
  amountContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  amountSecondary: {
    color: '#a5a5a5',
  },
  amount: {
    marginTop: 3,
    paddingTop: 3,
    borderTop: 'solid 1px #dcdcdc',
  },
  icon: {
    marginRight: 10,
    fontSize: 24
  },
  navigator: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 'auto',
  },
})

const DepositDetails = ({classes, deposit}) => {
  const {full_address_string, operation_number, datetime, transport_cost = 0, total_storage_cost = 0} = deposit

  const totalCost = total_storage_cost + transport_cost

  return (
    <Grid container item spacing={0} className={classes.container}>
      <div className={classes.titleContainer}>
        <Title className={classes.title}>Resumen de tu operación</Title>
      </div>
      <Grid container spacing={8} className={classes.content}>
        <Grid item container className={classes.item} spacing={16}>
          <Grid item xs={6} className={classes.labelContainer}>
            <CheckCircleIcon className={classes.icon}/>
            <Typography variant="body2" className={classes.label}>Operación</Typography>
          </Grid>
          <Grid item xs={6} className={classes.valueContainer}>
            <Typography variant="body2" color="primary">#{operation_number}</Typography>
          </Grid>
        </Grid>
        <Grid item container className={classes.item} spacing={16}>
          <Grid item xs={6} className={classes.labelContainer}>
            <HomeIcon className={classes.icon} />
            <Typography variant="body2">Dirección de retiro</Typography>
          </Grid>
          <Grid item xs={6} className={classes.valueContainer} >
            <Typography variant="body2" color="primary">{full_address_string}</Typography>
          </Grid>
        </Grid>
        <Grid item container className={classes.item} spacing={16}>
          <Grid item xs={6} className={classes.labelContainer}>
            <DateRangeIcon className={classes.icon} />
            <Typography variant="body2">Fecha de retiro</Typography>
          </Grid>
          <Grid item xs={6} className={classes.valueContainer}>
            <Typography variant="body2" color="primary">
              {moment(datetime).format('LL')}<br/>
            </Typography>
          </Grid>
        </Grid>
        <Grid item container className={classes.item} spacing={16}>
          <Grid item xs={6} className={classes.labelContainer}>
            <ScheduleIcon className={classes.icon} />
            <Typography variant="body2">Horario de retiro</Typography>
          </Grid>
          <Grid item xs={6} className={classes.valueContainer}>
            <Typography variant="body2" color="primary">{moment.utc(datetime).local().format('LT')}</Typography>
          </Grid>
        </Grid>
        <Grid item container style={{margin: 0}} spacing={16}>
          <Grid item xs={6} className={classes.labelContainer}>
            <MonetizationOnIcon className={classes.icon} />
            <Typography variant="body2">Monto</Typography>
          </Grid>
          <Grid item xs={6} className={classes.amountContainer}>
            <Typography variant="body2" className={classes.amountSecondary}>
              ${formatNumber(total_storage_cost)} - guardado mensual
            </Typography>
            <Typography variant="body2" className={classes.amountSecondary}>
              ${formatNumber(transport_cost)} - flete
            </Typography>
            <Typography variant="body2" color="primary" className={classes.amount}>
              ${formatNumber(totalCost)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

DepositDetails.propTypes = {
  deposit: PropTypes.object,
  userName: PropTypes.string,
  address: PropTypes.string,
}

export default withStyles(styles, {withTheme: true})(DepositDetails)



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/components/DepositDetails.js